// Week labels for the project workspace's crew charts.
//
// In lib/ so the labelling can be tested without rendering the tab (importing
// ManpowerTab drags in apiClient → MSAL config, which needs a browser env).

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * The bare date of a Sunday-anchored week start, e.g. "Sep 20".
 *
 * Built from the string rather than a Date so no timezone can shift it a day (a
 * UTC-parsed date lands the previous evening in Eastern).
 *
 * ⚠️ On its own this is AMBIGUOUS next to a crew figure — see weekBarLabel.
 */
export function weekLabel(weekStart: string): string {
  const [, m, d] = weekStart.split('-');
  return `${MONTHS[Number(m) - 1]} ${Number(d)}`;
}

/**
 * The same date, marked as a WEEK: "wk Sep 20".
 *
 * #452: a scheduler shifted a job by 7 days, read "Sep 14" off the Next
 * scheduled tile beforehand and "Sep 20" off this chart afterwards, and filed a
 * bug saying the shift had only moved 6 days. It had moved 7 — to Monday the
 * 21st — but our weeks start on Sunday, so the bar holding it is labelled with
 * the 20th. A bare date sitting directly under a crew count reads as the day
 * the crew starts, and there was nothing on the label to say otherwise (the
 * "Week of …" wording existed only in the hover tooltip, which is invisible on
 * touch and easy to miss anywhere else).
 *
 * Mirrors the crew grid's own weekly columns, which have always printed a
 * visible "wk of" above the date for exactly this reason.
 */
export function weekBarLabel(weekStart: string): string {
  return `wk ${weekLabel(weekStart)}`;
}
